import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

const col1 = categories.slice(0, 5);
const col2 = categories.slice(5, 10);
const col3 = categories.slice(10, 14);

export default function Footer() {
  return (
    <footer className="bg-background-100 pt-16 pb-8 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block">
              <span className="font-heading text-xl font-bold text-foreground-950">
                itaobuy<span className="text-primary-500">.living</span>
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              Your gateway to smarter cross-border product sourcing through the <strong>itaobuy spreadsheet</strong> system. Browse curated categories, compare prices, and shop with confidence.
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line w-3.5 h-3.5 flex items-center justify-center"></i>
              Back to Home
            </Link>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              Product Categories
            </h4>
            <ul className="space-y-2">
              {col1.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              &nbsp;
            </h4>
            <ul className="space-y-2">
              {col2.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              &nbsp;
            </h4>
            <ul className="space-y-2">
              {col3.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} itaobuy.living — All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">Privacy</Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}